import { jsx } from "react/jsx-runtime";
import TaskIcon from "@mui/icons-material/Task";
import { validateTidalLicense } from "../../base/index.js";
function Task(props) {
  return /* @__PURE__ */ jsx(
    TaskIcon,
    {
      "data-testid": "Task",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Task",
      "data-tidal-icon-meta": "folders,notes,lists"
    }
  );
}
Task.tidalIconMeta = {
  categories: "folders,notes,lists",
  name: "Task"
};
validateTidalLicense();
export {
  Task
};
//# sourceMappingURL=Task.js.map
